import { render, staticRenderFns } from "./ClientColumn.vue?vue&type=template&id=2abe36a8&scoped=true"
import script from "./ClientColumn.vue?vue&type=script&lang=js"
export * from "./ClientColumn.vue?vue&type=script&lang=js"
import style0 from "./ClientColumn.vue?vue&type=style&index=0&id=2abe36a8&prod&scoped=true&lang=css"
import style1 from "./ClientColumn.vue?vue&type=style&index=1&id=2abe36a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abe36a8",
  null
  
)

export default component.exports